export var Status;
(function (Status) {
    Status["idol"] = "idol";
    Status["failed"] = "failed";
    Status["inProgress"] = "inProgress";
    Status["complete"] = "complete";
})(Status || (Status = {}));
export var CoreEvents;
(function (CoreEvents) {
    CoreEvents["start"] = "start";
    CoreEvents["stop"] = "stop";
    CoreEvents["reset"] = "reset";
})(CoreEvents || (CoreEvents = {}));
